import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { PlanConfirmationComponent } from './plan-confirmation/plan-confirmation.component';
import { PlanGridComponent } from './plan-grid/plan-grid.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

import { MaterialModule } from './material-module';
import { BreadcrumbHeaderComponent } from './breadcrumb-header/breadcrumb-header.component';
import { BreadcrumbTrailComponent } from './breadcrumb-trail/breadcrumb-trail.component';
import { BreadcrumbComponent } from './breadcrumb-trail/breadcrumb/breadcrumb.component';
import { PlanDetailsModalComponent } from './plan-details-modal/plan-details-modal.component';
import { MetalLevelBoxComponent } from './components/metal-level-box/metal-level-box.component';
import { PlanListComponent } from 'src/app/plan-list/plan-list.component';
import { PlanCardComponent } from './plan-card/plan-card.component';
import { PlanCardGroupComponent } from './plan-card-group/plan-card-group.component';
import { EnrollmentButtonComponent } from './enrollment-button/enrollment-button.component';
import { WarningModalComponent } from './enrollment-button/warning-modal/warning-modal.component';
import { CookieService } from 'ngx-cookie-service';
import { SnackBarComponent } from './components/snackbar/snackbar.component';
import { SendToEaseModalComponent } from './send-to-ease-modal/send-to-ease-modal.component';

const appRoutes: Routes = [
    { path: 'planConfirmation/:quoteId/:enrollmentId', component: PlanConfirmationComponent },
    { path: 'planconfirmation/:quoteId/:enrollmentId', component: PlanConfirmationComponent },
    { path: '**', component: PageNotFoundComponent }
];

@NgModule({
    declarations: [
        AppComponent,
        PlanConfirmationComponent,
        PlanGridComponent,
        PageNotFoundComponent,
        BreadcrumbHeaderComponent,
        BreadcrumbTrailComponent,
        BreadcrumbComponent,
        PlanDetailsModalComponent,
        MetalLevelBoxComponent,
        PlanListComponent,
        PlanCardComponent,
        PlanCardGroupComponent,
        EnrollmentButtonComponent,
        WarningModalComponent,
        SnackBarComponent,
        SendToEaseModalComponent
    ],
    //entryComponents: [PlanDetailsModalComponent, WarningModalComponent, SnackBarComponent,SendToEaseModalComponent],
    imports: [
        RouterModule.forRoot(appRoutes, { enableTracing: true, relativeLinkResolution: 'corrected' }),
        BrowserModule,
        BrowserAnimationsModule,
        MaterialModule,
        HttpClientModule
    ],
    exports: [WarningModalComponent],
    providers: [CookieService],
    bootstrap: [AppComponent]
})
export class AppModule {}
